import React from "react";
import context from "react-bootstrap/esm/AccordionContext";
import HomeFaq from "../../data/Faq/home.json";
import FaqList from "./FaqList";

const FrequentlyAskedQuestions = () => {
  console.log(HomeFaq);
  return (
    <>
      {/* ======= Frequently Asked Questioins Section ======= */}
      <section id="faq" className="faq section-bg d-none">
        <div className="container" data-aos="fade-up">
          <div className="row">
            <div className="col-lg-4">
              <img
                src="/assets/img/home/faq.jpg"
                className="img-fluid"
                alt="female doctor standing wearing stethoscope"
              />
            </div>

            <div className="col-lg-8 faqSecDiv">
              <div className="section-title whiteBg">
                <h2>Frequently Asked Questioins</h2>
                <p>
                  Because of environmental changes skin disease will also be on
                  rise . With Corona around, you are not able to meet skin
                  specialist / Dermatologist. So, here are the tips to follow
                  and get relieved from skin disease.
                </p>
              </div>

              <FaqList arr={HomeFaq} />
            </div>
          </div>
        </div>
      </section>
      {/* End Frequently Asked Questioins Section */}
    </>
  );
};

export default FrequentlyAskedQuestions;
